// extracted by mini-css-extract-plugin
export var locationCard = "_gp-0";